import { setStorage } from "@/helpers/LocalStorage";
export default class UserService {

    constructor() { }

    saveStorageData(data) {
        setStorage(data);
    }
}
